import { render, staticRenderFns } from "./topCom.vue?vue&type=template&id=2a2e392a&scoped=true&"
import script from "./topCom.vue?vue&type=script&lang=ts&"
export * from "./topCom.vue?vue&type=script&lang=ts&"
import style0 from "./topCom.vue?vue&type=style&index=0&id=2a2e392a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e392a",
  null
  
)

export default component.exports